import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getCountries, getCurrencies, getProcessType, getSectorTypes, getTimeZone, postEntities } from "../../services/rest";
import { useTranslation } from "react-i18next";
import { StyledAddButton, StyledCancelButton } from "./ClientsStyles";
import { clientInfoType, countryType, createClientsType, currencyType, EntityFormData, timeZoneType } from "../../actions/Types";
import { formatToDDMMYYYY, months } from "../../utils";
import { RootState } from '../../configureStore'
import { clientManagementEntity, entityManagementEntity, userManagementEntity, } from "../../reducers";
import { createClient, clientInfo, getOrgData } from "../../actions";
import { toast } from "react-toastify";


const initialFormData: EntityFormData = {
  entityName: "",
  sectorType: "",
  countryOfIncorporation: "",
  address: "",
  corporateAddress: "",
  dateOfIncorporation: null,
  amountsIn: "",
  decimalUpto: "",
  timezone: "",
  processtype: "",
  processtypeValue: [],
  financialYearStartMonth: "",
  clientId: "",
  entityType: "",
  referenceEntity: "",
  parentEntityName: "",
  parent: false,
  percentageHolding: 0,
  effectiveHolding: 0
};

interface OrgData {
  processTypes: string[];
  timeZones: timeZoneType[];
  countries: countryType[];
  currencies: currencyType[];
  sectorTypes: string[];
}
interface EntityFormProps {
  showEntitiesModal: boolean;
  setShowEntitiesModal: (res: boolean) => void
  AddedClientInfo: any
  entityCreationMode: string;
  clientInfo: clientInfoType['data']
  getDropdownData : any
  dropdownData : any
}
const DialogStack = { padding: '15px' }
const DialogActionSX = { padding: '0px 20px 24px 0px' }

const EntityForm: React.FC<EntityFormProps> = ({ showEntitiesModal, setShowEntitiesModal, AddedClientInfo, getDropdownData, clientInfo,dropdownData , }) => {
  const [orgData, setOrgData] = useState<OrgData>({
    processTypes: [],
    timeZones: [],
    countries: [],
    currencies: [],
    sectorTypes: [],
  });

  const { t } = useTranslation()
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const [formData, setFormData] = useState<EntityFormData>(initialFormData);
  const [errors, setErrors] = useState<Partial<Record<keyof EntityFormData, string>>>({});
  const [submitting, setSubmitting] = useState(false);

  // const getEntitiesData = async()=>{
  //   const res = await getAllEntity()
  //   console.log(res,)
  // }

  // useEffect(()=>{
  //   if(entityCreationMode=== "UPDATE"){
  //     getEntitiesData()
  //   }
  // },[entityCreationMode])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          processTypeRes,
          timeZoneRes,
          countriesRes,
          currenciesRes,
          sectorTypesRes
        ] = await Promise.all([
          getProcessType(),
          getTimeZone(),
          getCountries(),
          getCurrencies(),
          getSectorTypes()
        ]);

        setOrgData({
          processTypes: processTypeRes.data,
          timeZones: timeZoneRes.data,
          countries: countriesRes.data,
          currencies: currenciesRes.data,
          sectorTypes: sectorTypesRes.data,
        });
      } catch (err: any) {
        console.error("Error fetching organization data:", err);
        setError("Failed to load organizational data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "decimalUpto" ? (value === "" ? "" : Number(value)) : value,
    }));
  };

  console.log(dropdownData,"kkkkk")

  const handleDateChange = (value: any | null) => {
    setFormData((prev) => ({ ...prev, dateOfIncorporation: value }));
  };

  const validate = () => {
    const newErrors: typeof errors = {};
    if (!clientInfo.companyName) newErrors.entityName = "Required";
    if (!formData.countryOfIncorporation) newErrors.countryOfIncorporation = "Required";
    if (!formData.dateOfIncorporation) newErrors.dateOfIncorporation = "Required";
    if (!formData.amountsIn) newErrors.amountsIn = "Required";
    if (!formData.timezone) newErrors.timezone = "Required";
    if (formData.decimalUpto === "" || formData.decimalUpto === 0)
      newErrors.decimalUpto = "Required";
    else if (formData.decimalUpto < 0)
      newErrors.decimalUpto = "Cannot be negative";
    else if (!Number.isInteger(formData.decimalUpto))
      newErrors.decimalUpto = "Must be a whole number";
    else if (formData.decimalUpto > 10)
      newErrors.decimalUpto = "Cannot be greater than 10";

    if (!formData.financialYearStartMonth) newErrors.financialYearStartMonth = "Required";
    if (!formData.processtypeValue) newErrors.processtypeValue = "Required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setSubmitting(true);
    try {
      const res = await postEntities({
        ...formData,
        clientId: AddedClientInfo.code,
        processtype: formData.processtypeValue.join(","),
        entityName: clientInfo.companyName,
        dateOfIncorporation: formatToDDMMYYYY(formData.dateOfIncorporation)
      });
      if (res.status === 200) {
        setShowEntitiesModal(false);
        toast.success("Entity Created");
      }
    } catch (error) {
      console.error(error);
      toast.error("Entity Creation fail")
    }
    setSubmitting(false);
  };

  // useEffect(() => {
  //   getDropdownData();
  // }, []);


  return (
    <>
      <Dialog
        open={showEntitiesModal}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        sx={DialogStack}
      >
        <DialogTitle id='selectEntities' alignSelf={'center'}>
          {'Create Entity'}
        </DialogTitle>
        <DialogContent>
          {!loading ? <Box sx={{ p: 3 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    required
                    label="entityName"
                    name="entityName"
                    value={clientInfo.companyName}
                    onChange={handleChange}
                    error={!!errors.entityName}
                    helperText={errors.entityName}
                    disabled
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    select
                    required={false}
                    label="Sector"
                    name="sectorType"
                    value={formData.sectorType}
                    onChange={handleChange}
                  >
                    {orgData.sectorTypes.map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    select
                    label="Country of Incorporation"
                    name="countryOfIncorporation"
                    value={formData.countryOfIncorporation}
                    onChange={handleChange}
                    error={!!errors.countryOfIncorporation}
                    helperText={errors.countryOfIncorporation}
                  >
                    {orgData.countries.map(item => (<MenuItem value={item.name}>{item.name}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    required={false}
                    label="Registered Address"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    required={false}
                    label="Corporate Address"
                    name="corporateAddress"
                    value={formData.corporateAddress}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <DatePicker
                    label="Date of Incorporation"
                    value={formData.dateOfIncorporation}
                    onChange={handleDateChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        required
                        error={!!errors.dateOfIncorporation}
                        helperText={errors.dateOfIncorporation}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    required
                    select
                    label="Amount in"
                    name="amountsIn"
                    value={formData.amountsIn}
                    onChange={handleChange}
                    error={!!errors.amountsIn}
                    helperText={errors.amountsIn}
                  >
                    {orgData.currencies.map(item => (<MenuItem value={item.name}>{item.name}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    required
                    type="number"
                    label="Decimal Places"
                    name="decimalUpto"
                    value={formData.decimalUpto}
                    onChange={handleChange}
                    error={!!errors.decimalUpto}
                    helperText={errors.decimalUpto}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    required
                    select
                    label="Time Zone"
                    name="timezone"
                    value={formData.timezone}
                    onChange={handleChange}
                    error={!!errors.timezone}
                    helperText={errors.timezone}
                  >
                    {orgData.timeZones.map(item => (<MenuItem value={item.id.toString()}>{item.zonename}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    required
                    select
                    label="Regulation"
                    name="processtype"
                    value={formData.processtypeValue} // must be string[]
                    onChange={(e) => {
                      const {
                        target: { value },
                      } = e;
                      setFormData((prev) => ({
                        ...prev,
                        processtypeValue: typeof value === 'string' ? value.split(',') : value,
                      }));
                    }}
                    SelectProps={{
                      multiple: true,
                      renderValue: (selected) => (selected as string[]).join(', '),
                    }}
                    error={!!errors.processtype}
                    helperText={errors.processtype}
                  >
                    {orgData.processTypes.map((item) => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    required
                    select
                    label="Financial Year Start Month"
                    name="financialYearStartMonth"
                    value={formData.financialYearStartMonth}
                    onChange={handleChange}
                    error={!!errors.financialYearStartMonth}
                    helperText={errors.financialYearStartMonth}
                  >
                    {months.map((month) => (
                      <MenuItem key={month.id} value={month.id}>
                        {month.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </LocalizationProvider>
          </Box> : "Loading...."}
          <DialogActions sx={DialogActionSX}>
            <StyledAddButton
              onClick={handleSubmit}
              size='small'
            >
              {t('submit')}
            </StyledAddButton>
            <StyledCancelButton variant='outlined' size='small' onClick={() => setShowEntitiesModal(false)}>
              {t('cancel')}
            </StyledCancelButton>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};


const mapStateToProps = (state: RootState) => {
  return {
    AddedClientInfo: clientManagementEntity.getClientManagementData(state).createClients,
    clientInfo: clientManagementEntity.getClientManagementData(state).getClientInfo,
    dropdownData: entityManagementEntity.getEntity(state).getOrgDataReducer,
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    createClientData: (data: createClientsType) => dispatch(createClient.request(data)),
    getDropdownData: () => dispatch(getOrgData.request()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EntityForm);
